import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  title: {
    textAlign: 'center',
    marginBottom: '2rem',
    '& h1': {
      fontFamily: 'Fraunces, serif',
      fontWeight: 700,
      color: 'var(--color-plum)',
      letterSpacing: '-0.015em',
      margin: 0,
    },
  },
  emptyButton: {
    minWidth: '150px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '5px',
    },
    [theme.breakpoints.up('xs')]: {
      marginRight: '20px',
    },
  },
  link: {
    textDecoration: 'none',
    color: 'var(--color-coral)',
    fontWeight: 600,
    '&:hover': {
      color: 'var(--color-coral-deep)',
    },
  },
  cardDetails: {
    display: 'flex',
    marginTop: '2.5rem',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '1rem',
  },

  /* Override MUI table styles globally for the cart */
  '@global': {
    '.MuiTableContainer-root': {
      backgroundColor: 'var(--color-white)',
      borderRadius: '24px !important',
      boxShadow: '0 18px 50px rgba(61, 30, 92, 0.08) !important',
      border: '1px solid rgba(61, 30, 92, 0.05)',
      overflow: 'hidden',
    },
    '.MuiTable-root': {
      '& .MuiTableHead-root .MuiTableCell-root': {
        fontFamily: 'Inter, sans-serif',
        fontSize: '0.78rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: 'var(--color-text-soft)',
        backgroundColor: 'var(--color-pink-blush)',
        borderBottom: 'none',
        padding: '1rem 1.25rem',
      },
      '& .MuiTableBody-root .MuiTableCell-root': {
        fontFamily: 'Inter, sans-serif',
        fontSize: '0.95rem',
        color: 'var(--color-plum)',
        padding: '1.1rem 1.25rem',
        borderBottom: '1px solid rgba(61, 30, 92, 0.06)',
      },
      '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
        borderBottom: 'none',
      },
      '& .MuiTableBody-root .MuiTableRow-root:hover': {
        backgroundColor: 'rgba(255, 232, 225, 0.35)',
      },
      '& .MuiButton-root': {
        minWidth: '32px',
        padding: '4px 10px',
        borderRadius: '8px',
        fontWeight: 600,
        color: 'var(--color-plum)',
        '&:hover': {
          backgroundColor: 'var(--color-pink-blush)',
        },
      },
      '& .MuiIconButton-root svg': {
        color: 'var(--color-coral)',
      },
    },
  },

  finalRow: {
    backgroundColor: 'var(--color-cream)',
    '& .MuiTableCell-root': {
      fontFamily: 'Fraunces, serif !important',
      fontSize: '1.2rem !important',
      fontWeight: '600 !important',
      color: 'var(--color-plum) !important',
      borderTop: '2px solid var(--color-coral) !important',
      padding: '1.25rem !important',
    },
  },
}));
